export var IdTabs;
(function (IdTabs) {
    IdTabs[IdTabs["NoticesTab"] = 62] = "NoticesTab";
})(IdTabs || (IdTabs = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdTabs.ts
// module id = 1827
// module chunks = 3